import { useState } from "react";

import { Button, MenuItem, Select, TextField, Typography } from "@mui/material";
import classNames from "classnames";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";

import { apis, callApi } from "../../../../../api";
import { omitEmpty } from "../../../../../utils";

import "./safety.scss";

const reportTypes = [
	{
		key: "unfulfilledObjectivesOrLackOfPreparation",
		value: "Unfulfilled objectives or lack of preparation",
	},
	{
		key: "concernsAboutOperationalSafety",
		value: "Concerns about operational safety (e.g., airplane limitations)",
	},
	{
		key: "argumentsDuringFlight",
		value: "Arguments during flight",
	},
	{
		key: "actionsShowingDisrespect",
		value: "Actions showing disrespect",
	},
	{
		key: "harassmentOrThreateningBehavior",
		value: "Harassment or threatening behavior",
	},
	{ key: "assault", value: "Assault" },
	{ key: "accountDeletion", value: "Account Deletion" },
	{ key: "other", value: "Other" },
];

export function Safety() {
	const [searchParams] = useSearchParams();
	const getFromSearchParams = !!reportTypes.find(
		(type) => (searchParams.get("type") ?? "") === type.key,
	);
	const [reportType, setReportType] = useState(
		getFromSearchParams ? searchParams.get("type") : "none",
	);
	const [reportReason, setReportReason] = useState("");
	const isDisabled = reportType === "none" || reportReason.trim() === "";

	const onClickSubmitSafety = async () => {
		try {
			const body = omitEmpty({ reportType, reportReason });
			await callApi({
				method: "POST",
				url: apis.REPORTS,
				body,
			});

			setReportType("none");
			setReportReason("");
			toast.success("Thank you for your report. We will take action!");
		} catch (error) {}
	};

	return (
		<div className="right-column-content-container">
			<div className="safety-container">
				<Typography className="small-title-text bold">Safety</Typography>
				<Typography className="normal-text item-separator-tiny">
					Are you feeling unsafe? Report any unsafe activity here. ORKA is
					committed to creating a safe space for everyone.
				</Typography>
				<Select
					style={{ marginTop: 16 }}
					className="normal-text"
					value={reportType}
					onChange={(e) => {
						if (e.target.value !== "none") {
							setReportType(e.target.value);
						}
					}}
					fullWidth>
					<MenuItem className="normal-text" value="none" disabled>
						Choose reason for your report
					</MenuItem>
					{reportTypes.map((type) => (
						<MenuItem className="normal-text" value={type.key} key={type.key}>
							{type.value}
						</MenuItem>
					))}
				</Select>
				<TextField
					multiline
					fullWidth
					className="item-separator-small"
					slotProps={{
						input: {
							classes: {
								input: "reason-input",
							},
						},
					}}
					value={reportReason}
					onChange={(e) => {
						setReportReason(e.target.value);
					}}
					placeholder="We are sorry to hear that you feel unsafe at this time, in a few words explain your reasons for your report..."
					rows={8}
				/>
				<div className="submit-safety-button-container item-separator-small">
					<Button
						className={classNames("normal-button no-transform", {
							"primary-button": !isDisabled,
							"disabled-button": isDisabled,
						})}
						onClick={onClickSubmitSafety}>
						Submit
					</Button>
				</div>
			</div>
		</div>
	);
}
